import MenuPanel from './MenuPanel'

export default MenuPanel


// WEBPACK FOOTER //
// ./src/components/Menu/MenuPanel/index.js